import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.collab.member.profile');
import { OnInit, OnChanges, Input, SimpleChanges } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-lpsysadmin-collab-member-profile',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/portal.lpsysadmin.collab.member.profile/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PortalLpsysadminCollabMemberProfileComponent implements OnInit, OnChanges {
    constructor(@Inject( Service) public service: Service) { }

    @Input() user_id: string = '';

    public profile: any = null;
    public activities: any[] = [];
    public me: string = '';
    public loaded: boolean = false;
    public editing: boolean = false;
    public statusForm: any = { presence: 'online', status_message: '' };

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public async ngOnChanges(c: SimpleChanges) {
        if (c['user_id'] && !c['user_id'].firstChange) {
            await this.load();
        }
    }

    public async load() {
        if (!this.user_id) return;
        const res = await wiz.call("info", { user_id: this.user_id });
        if (res.code === 200) {
            this.profile = res.data.profile;
            this.activities = res.data.activities || [];
            this.me = res.data.me;
            this.statusForm.presence = this.profile.presence || 'online';
            this.statusForm.status_message = this.profile.status_message || '';
        } else {
            this.service.alert.error(res.data?.message || '조회 실패');
        }
        this.loaded = true;
        await this.service.render();
    }

    public get isMe(): boolean {
        return this.me && this.profile && this.me === this.profile.id;
    }

    public async saveStatus() {
        const res = await wiz.call("update_my_status", this.statusForm);
        if (res.code === 200) {
            this.editing = false;
            this.service.alert.success('상태가 변경되었습니다.');
            await this.load();
        }
    }

    public presenceColor(p: string): string {
        const m: any = {
            online: 'bg-emerald-500', away: 'bg-amber-500',
            busy: 'bg-rose-500', offline: 'bg-zinc-300',
        };
        return m[p] || 'bg-zinc-300';
    }

    public presenceLabel(p: string): string {
        const m: any = { online: '온라인', away: '자리비움', busy: '바쁨', offline: '오프라인' };
        return m[p] || '오프라인';
    }
}

export default PortalLpsysadminCollabMemberProfileComponent;